'use client'

import { Text } from '@/components/Text/Text';
import pageStyles from '../page.module.css';
import homepageHeaderStyles from '../_components/HomePageHeader/homepage-header.module.css';

export default function Forbidden() {

    return (
      <div className={pageStyles.container} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <div className={homepageHeaderStyles.header}>
          <div>
            <Text color="primary" variant="title1">403 - Forbidden</Text>
          </div>
          <Text color="primary" variant="subtitle1">You don&apos;t have permission to access this page.<br/><strong>Make sure you have Adobe&apos;s VPN enabled.</strong>
          </Text>
        </div>
      </div>
    )
  }